<template>
  <div class="mainWrapper">
    <div class="mainContentWrapper">
      <div class="mainHeaderWrapper">
        <div class="mainHeaderLargeHeadLine">안녕하세요 <span style="font-weight: bold;">{{$store.getters.getAdUserStateValue('name')}}</span>님!</div>
        <div class="mainHeaderMiddleHeadLine">광고현황을 보여드리겠습니다.</div>
        <my-info-noti/>
      </div>
      <div class="chartElementsWrapper">
        <chart v-bind="exposedCntChart"></chart>
        <chart v-bind="answeredCntChart"></chart>
        <chart v-bind="adFeeChart"></chart>
      </div>
      <div class="linkButtonsWrapper">
        <link-button v-bind="adLinkButton"></link-button>
        <link-button v-bind="paymentButton"></link-button>
        <link-button v-bind="premiereButton"></link-button>
      </div>
    </div>
    <board-footer></board-footer>
  </div>
</template>

<script>
import chart from '../../board/elements/mainBoardchart'
import linkButton from '../../board/elements/linkButton'
import myInfoNotiModal from '../../board/elements/myInfoModifyNotificationModal'
import boardFooter from '../elements/boardFooter'
import store from '../../../store'

export default {
  components: {
    'chart': chart,
    'link-button': linkButton,
    'my-info-noti': myInfoNotiModal,
    'board-footer': boardFooter
  },
  data () {
    return {
      exposedCntChart: {
        title: '총 도달수',
        count: '',
        percentAvailable: false,
        isArrowUp: true,
        percentValue: 0,
        chartType: 'exposedCnt',
        chartData: {
          labels: [],
          datasets: [
            {
              label: '남성',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#0099FF',
              hoverBorderWidth: 0,
              barPercentage: 0.3
            },
            {
              label: '여성',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#FFBF60',
              hoverBorderWidth: 0,
              barPercentage: 0.3
            },
            {
              label: '성별모름',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#C7C7C7',
              hoverBorderWidth: 0,
              barPercentage: 0.3
            }
          ]
        }
      },
      answeredCntChart: {
        title: '총 참여수',
        count: '',
        percentAvailable: false,
        isArrowUp: true,
        percentValue: 0,
        chartType: 'answeredCnt',
        chartData: {
          labels: [],
          datasets: [
            {
              label: '남성',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#0099FF',
              hoverBorderWidth: 0,
              barPercentage: 0.3
            },
            {
              label: '여성',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#FFBF60',
              hoverBorderWidth: 0,
              barPercentage: 0.3
            },
            {
              label: '성별모름',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#C7C7C7',
              hoverBorderWidth: 0,
              barPercentage: 0.3
            }
          ]
        }
      },
      adFeeChart: {
        title: '총 광고비',
        count: '',
        percentAvailable: false,
        isArrowUp: true,
        percentValue: 0,
        chartType: 'adFee',
        chartData: {
          labels: [],
          datasets: [
            {
              label: '광고비',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: '#0099FF',
              hoverBorderWidth: 0,
              barPercentage: 0.3
            }
          ]
        }
      },
      adLinkButton: {
        title: '광고? no, 이젠 질문하기!!',
        text: '아직도 광고만 하세요? 이제 질문하면서 광고도 하고 고객들의 의견을 들어보세요.',
        imgType: 0,
        goToURL: '/board/enroll'
      },
      paymentButton: {
        title: '충전하기',
        text: '고객들의 솔직한 의견을 들을 수 있도록 포인트를 충전하세요.',
        imgType: 1,
        goToURL: '/board/fee-info'
      },
      premiereButton: {
        title: '프리미엄',
        text: '고객에 대한 자세한 분석 자료를 통해 당신의 매출을 늘려드립니다. ',
        imgType: 2,
        goToURL: '/premiere'
      }
    }
  },
  methods: {
    showMyInfoModifyModal: function () {
      this.$modal.show('myInfoModifyNotification', {type: 'init'})
    },
    setChartData: function (chart, responseData, type) {
      // 퍼센트
      if(responseData.percentage != null && responseData.percentage < 100) {
        // 감소
        chart.percentAvailable = true
        chart.percentValue = 100 - responseData.percentage
        chart.isArrowUp = false
      }else if(responseData.percentage != null && responseData.percentage >= 100) {
        // 증가
        chart.percentAvailable = true
        chart.percentValue = responseData.percentage - 100
        chart.isArrowUp = true
      }

      // 라벨
      let firstDay = this.$moment().add(-31, 'days')
      for(var i = 0; i < 30; i++) {
        chart.chartData.labels.push(firstDay.add(1, 'days').format('MM/DD'))
      }

      let totalCount = 0
      if(type === 'exposedCnt' || type === 'answerCnt') {
        // 도달수, 참여수의 경우
        // eslint-disable-next-line no-redeclare
        for(var i = 0; i < responseData.lastMonthData.length; i++) {
          // 데이터 수치
          let dataPerDay = responseData.lastMonthData[i].totalChartDataPerDay
          let date = this.$moment(responseData.lastMonthData[i].date).format('MM/DD')
          if(responseData.lastMonthData[i].gender === 'MALE') {
            chart.chartData.datasets[0].data[chart.chartData.labels.findIndex(items => items === date)] += dataPerDay
          }else if (responseData.lastMonthData[i].gender === 'FEMALE') {
            chart.chartData.datasets[1].data[chart.chartData.labels.findIndex(items => items === date)] += dataPerDay
          }else {
            chart.chartData.datasets[2].data[chart.chartData.labels.findIndex(items => items === date)] += dataPerDay
          }

          // 전체 수
          totalCount += dataPerDay
        }
        chart.count = totalCount + '명'
      }else if(type === 'adFee') {
        // 광고비의 경우
        // eslint-disable-next-line no-redeclare
        for(var i = 0; i < responseData.lastMonthData.length; i++) {
          // 데이터 수치
          let dataPerDay = responseData.lastMonthData[i].totalChartDataPerDay
          let dataPerDayToWonUnit = parseInt(dataPerDay) / 10000
          let date = this.$moment(responseData.lastMonthData[i].date).format('MM/DD')
          chart.chartData.datasets[0].data[chart.chartData.labels.findIndex(items => items === date)] += dataPerDayToWonUnit

          // 전체 수
          totalCount += dataPerDayToWonUnit
        }
        chart.count = Math.floor(totalCount) + '만원'
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let exposedChartResponse = await store.dispatch('exposedChartDataApi')
      let answeredChartResponse = await store.dispatch('answeredChartDataApi')
      let adFeeChartResponse = await store.dispatch('adFeeChartDataApi')
      if(exposedChartResponse.data.result.code === 3000 || answeredChartResponse.data.result.code === 3000 || adFeeChartResponse.data.result.code === 3000) {
        // 해당 유저의 광고가 없을 경우
        next(vm => {
          // 회원가입후 첫 유저라면 정보 수정 안내 모달 띄움
          if(to.params.initUser) {
            vm.showMyInfoModifyModal()
          }
          let voidDataSet = {
            lastMonthData: [],
            percentage: null
          }
          vm.setChartData(vm.exposedCntChart, voidDataSet, 'exposedCnt')
          vm.setChartData(vm.answeredCntChart, voidDataSet, 'answerCnt')
          vm.setChartData(vm.adFeeChart, voidDataSet, 'adFee')
        })
      }else{
        next(vm => {
          vm.setChartData(vm.exposedCntChart, exposedChartResponse.data.data, 'exposedCnt')
          vm.setChartData(vm.answeredCntChart, answeredChartResponse.data.data, 'answerCnt')
          vm.setChartData(vm.adFeeChart, adFeeChartResponse.data.data, 'adFee')
        })
      }
    }catch (error) {
      console.log(error.response)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/board.css';
.mainWrapper {
  position: relative;
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  justify-content: space-between;
  flex: 0.97;
  background-color: white;
  margin: 0;
  padding-top: 0;
}

.mainContentWrapper{
  padding-right: 32px;
  padding-left: 32px;
}

.mainHeaderWrapper{
  padding-bottom: 30px;
}

.mainHeaderLargeHeadLine{
  font-size: 24px;
  padding-top: 70px;
}

.mainHeaderMiddleHeadLine {
  font-size: 20px;
}

.chartElementsWrapper{
  display: flex;
  display: -ms-flexbox;
  justify-content: space-between;
}

.linkButtonsWrapper{
  margin-top: 25px;
  display: flex;
  display: -ms-flexbox;
  justify-content: space-between;
  height: 160px;
}

</style>



// WEBPACK FOOTER //
// src/components/board/views/mainBoard.vue